/**
 * تبدیل تاریخ میلادی به شمسی برای نمایش، بدون نیاز به کتابخانه‌ی جدید
 * (از Intl بومی مرورگر استفاده می‌کنه)
 */
export function toJalali(dateInput, options = { year: 'numeric', month: 'long', day: 'numeric' }) {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return dateInput;
  try {
    return new Intl.DateTimeFormat('fa-IR', options).format(date);
  } catch (e) {
    return dateInput;
  }
}
